
// Copyright 2002-2013, University of Colorado Boulder

//TODO rename this RectanglePushButton?
/**
 * A rectangular button. The background fill changes to give feedback about state. The content node is centered in the rectangle.
 *
 * @author Chris Malley (PixelZoom, Inc.)
 */
define( 'SUN/RectangleButton',['require','ASSERT/assert','SCENERY/util/Color','PHET_CORE/inherit','SCENERY/nodes/Node','SUN/PushButton','SCENERY/nodes/Rectangle'],function( require ) {
  'use strict';

  // imports
  var assert = require( 'ASSERT/assert' )( 'sun' );
  var Color = require( 'SCENERY/util/Color' );
  var inherit = require( 'PHET_CORE/inherit' );
  var Node = require( 'SCENERY/nodes/Node' );
  var PushButton = require( 'SUN/PushButton' );
  var Rectangle = require( 'SCENERY/nodes/Rectangle' );

  // Creates a node that represents the button is a specific state.
  var createNode = function( content, stroke, fill, rectangleLineWidth, rectangleXMargin, rectangleYMargin, rectangleCornerRadius ) {
    var node = new Node();
    var rectangle = new Rectangle(
      0, 0, content.width + rectangleXMargin + rectangleXMargin, content.height + rectangleYMargin + rectangleYMargin, rectangleCornerRadius, rectangleCornerRadius,
      { stroke: stroke, fill: fill, rectangleLineWidth: rectangleLineWidth } );
    node.addChild( rectangle );
    node.addChild( content );
    content.centerX = rectangle.centerX;
    content.centerY = rectangle.centerY;
    return node;
  };

  /**
   * @param {Node} content
   * @param {Function} callback
   * @param options
   * @constructor
   */
  function RectangleButton( content, callback, options ) {

    //TODO it would be nice to have less-verbose names, but supertypes may have similar options. For example, TextButton has textFill.
    options = _.extend( {
        // stroke
        rectangleStroke: 'black',
        rectangleStrokeDisabled: 'rgb(175,175,175)',
        // fill
        rectangleFillUp: new Color( 255, 200, 0 ),
        rectangleFillDisabled: 'white',
        // options that apply to all states
        rectangleLineWidth: 1,
        rectangleXMargin: 5,
        rectangleYMargin: 5,
        rectangleCornerRadius: 10
      },
      options );

    // generated colors
    assert && assert( options.rectangleFillUp instanceof Color ); //TODO can we relax this requirement?
    options.rectangleFillOver = options.rectangleFillOver || options.rectangleFillUp.brighterColor( 0.9 );
    options.rectangleFillDown = options.rectangleFillDown || options.rectangleFillUp.darkerColor( 0.9 );

    PushButton.call( this,
      createNode( content, options.rectangleStroke, options.rectangleFillUp, options.rectangleLineWidth, options.rectangleXMargin, options.rectangleYMargin, options.rectangleCornerRadius ),
      createNode( content, options.rectangleStroke, options.rectangleFillOver, options.rectangleLineWidth, options.rectangleXMargin, options.rectangleYMargin, options.rectangleCornerRadius ),
      createNode( content, options.rectangleStroke, options.rectangleFillDown, options.rectangleLineWidth, options.rectangleXMargin, options.rectangleYMargin, options.rectangleCornerRadius ),
      createNode( content, options.rectangleStrokeDisabled, options.rectangleFillDisabled, options.rectangleLineWidth, options.rectangleXMargin, options.rectangleYMargin, options.rectangleCornerRadius ),
      callback, options );
  }

  return inherit( PushButton, RectangleButton );
} );
